import React, { Component } from 'react'

class UserList extends Component {

    render() {
        return (<div>UserList</div>)
    }
}

export default UserList


/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/ChatComponents/UserList.js
 **/